import { createSelector } from "@ngrx/store";
import * as fromCommon from "../reducers/common.reducer";
import { AppState } from "../reducers/app.reducer";

export const selectCommon = (state: AppState) => state.common;

export const selectIsMobileView = createSelector(
    selectCommon,
    (state: fromCommon.IState) => state.isMobileView
);

export const selectSpinner = createSelector(
    selectCommon,
    (state: fromCommon.IState) => state.inProgress
);

export const showGridActions = createSelector(
    selectCommon,
    (state: fromCommon.IState) => state.showGridActions
);

export const selectSubmissions = createSelector(
    selectCommon,
    (state: fromCommon.IState) => state.submissions
);

export const selectBreadCrumbs = createSelector(
    selectCommon,
    (state: fromCommon.IState) => state.breadCrumbs
);

export const selectProject = createSelector(
    selectCommon,
    (state: fromCommon.IState) => state.selectedProject
);

export const selectForm = createSelector(
    selectCommon,
    (state: fromCommon.IState) => state.selectedForm
);
